import React from "react"; 
import styles from '../../css/Part11.module.css';

function ImageComponent() {
  return (
    <section className={styles.imageWrapper} id="section_Team">
      <h2 className={styles.teamTitle}>Professional Team</h2>
      {/* Green background */}
      <img 
        src="/images/background/Group 72.png" 
        className={styles.fullWidthImage} 
        alt="background"
      />
      
      {/* Images of people */}
      <div className={styles.peopleWrapper}>
        <img src="/images/team/JpChin.png" alt="Person 1" className={styles.personImage} />
        <img src="/images/team/TM.png" alt="Person 2" className={styles.personImage} />
        <img src="/images/team/Kamil.png" alt="Person 3" className={styles.personImage} />
        <img src="/images/team/Javen.png" alt="Person 4" className={styles.personImage} />
      </div>

    </section>
  );
}

export default ImageComponent;
